import api from '@/apis/dvc/dCSDFileAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('dCSDFile', api);

const state = {
  ...crud.state,
  _config: {
    table: 'dcsd_file',
    field: {
      key: 'dcsd_file_id',
      code: 'file_code',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
